import React from "react";
import ButtonArrow from "../components/ButtonArrow";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { axiosConfig } from "../Helpers/AxiosRequest";
import Activity from "../components/Activity";
import CarouselComponent from "../components/CarouselComponent";
import { useHeader } from "../Contexts/HeaderContext";
import { API_URL } from "../Helpers/api";
import shuffleArray from "../Helpers/ShuffleArray";
import { Helmet } from "react-helmet";
import activitiesImg from "../Images/actividades.jpg"

const Activities = () => {
  // const { marginTop } = useHeader();
  const [activities, setActivities] = useState();

  useEffect(() => {
    axios(axiosConfig("GET", `${API_URL}/advertising/get-active-adds/activity`, null, true))
      .then((res) => {
        if (res.data.success) {
          const shuffledAdds = shuffleArray(res.data.adds);
          setActivities(shuffledAdds);
        } else {
          console.warn("No activitiy adds found");
        }
      })
      .catch((err) => console.error(err.message));
  }, []);

  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Actividades en Bella Unión – Turismo, Cultura y Aventura</title>
        <meta
          name="description"
          content="Vive actividades al aire libre en Bella Unión: senderismo, paseos guiados, experiencias culturales y diversión para toda la familia."
        />
        <meta
          name="keywords"
          content="actividades Bella Unión, turismo aventura Uruguay, senderismo Bella Unión, paseos guiados, experiencias culturales Bella Unión"
        />
        <link rel="canonical" href="https://bellaunion.uy/actividades" />
        <meta property="og:title" content="Actividades en Bella Unión – Turismo, Cultura y Aventura" />
        <meta
          property="og:description"
          content="Vive actividades al aire libre en Bella Unión: senderismo, paseos guiados, experiencias culturales y diversión para toda la familia."
        />
        <meta property="og:url" content="https://bellaunion.uy/actividades" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={activitiesImg} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Actividades en Bella Unión – Turismo, Cultura y Aventura" />
        <meta
          name="twitter:description"
          content="Vive actividades al aire libre en Bella Unión: senderismo, paseos guiados, experiencias culturales y diversión para toda la familia."
        />
        <meta name="twitter:image" content={activitiesImg} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Actividades</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light" id="main-container" style={{ marginTop: "100vh" }}>
        <div className="container pt-5">
          <h2 className="text-center">Actividades</h2>
          {activities?.length > 0 ? (
            <>
              <div className="row align-items-stretch g-3 activity py-5">
                {activities.map((activity, i) => (
                  <Activity data={activity} index={i} key={activity._id} />
                ))}
              </div>
            </>
          ) : (
            <p className="fs-2 fw-light text-center">No se encontraron actividades</p>
          )}
        </div>
      </div>
    </main>
  );
};

export default Activities;
